<button *ngIf="show" mat-icon-button (click)="toggleMenu()" aria-label="Abrir menú">
  <mat-icon>menu</mat-icon>
</button>
